import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageProvider";
import "./LanguageSelector.sass";

function LanguageSelector({ onSelect }) {
    const { language, languages, switchLanguagePath } = useLanguage();
    const navigate = useNavigate();

    const handleChange = (event) => {
        navigate(switchLanguagePath(event.target.value));
        onSelect?.();
    };

    return (
        <div className="language-selector" aria-label="Language selector">
            <select
                className="language-selector__select"
                value={language}
                onChange={handleChange}
                aria-label="Select language">
                {languages.map((item) => (
                    <option key={item.code} value={item.code} lang={item.htmlLang}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default LanguageSelector;
